import { Alert, Divider, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useState, useEffect } from "react";
import useAdminDataStore, { selectCurrentGroupId, selectAllGroups } from "../../../store/adminData/adminData";
import useUserStore, { selectUserDetails } from "../../../store/user/user";
import StoreItem from "../../../models/admin/StoreItem";
import { db } from "../../../services/firebaseService/connection";
import { uploadImage } from "../../../services/firebaseService/endPoints/admin/members";
import {
  addItem,
  getItem,
  updateItem,
} from "../../../services/firebaseService/endPoints/admin/store";
import { Input } from "antd";
import { ChantInput, ChantSelect, ChantCheckbox } from "../../../CommonComponents";
import ImageUploadButton from "../website/ImageUploaderButton";
import {
  getCurrencyUnicode,
  postUpdateCDNUtil,
} from "../../../helperFunctions/util";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  increment,
  writeBatch,
} from "@firebase/firestore";
import { verifyStripeAccountId } from "../../../utils/errors";
import { withRouter } from "../../../utils/helper";
import logger from "../../../utils/logger";
import {
  ChantButton,
  DescriptionText,
  ScreenHeader,
} from "../../../CommonComponents";
const statuses = ["Live", "Inactive"].map((value) => ({
  key: value.toLowerCase(),
  value,
}));
const quantityPerPriceOption = [
  { key: "single", value: "Set single quantity/price combination for product" },
  {
    key: "perCombination",
    value: "Set quantity and price by size or size/color combination",
  },
];

const displayOptions = [
  {
    label: "Web Store",
    value: "web",
    helpText:
      "Make available for sale in Store (non-member pricing) and as upsell while buying a member package (member pricing)",
  },
  {
    label: "Registration",
    value: "registration",
    helpText:
      " For items to be 'included' as merchandise in member packages. After checking here, go to your Member Package and link the item. Linking to a package allows you to manage fulfillment via the Store Orders report.",
  },
];

const allTshirtSizes = [
  "One Size",

  "Youth Small",

  "Youth Medium",

  "Youth Large",

  "Youth XL",

  "Adult XS",

  "Adult Small",

  "Adult Medium",

  "Adult Large",

  "Adult XL",

  "Adult 2XL",

  "Adult 3XL",

  "Adult 4XL",

  "Adult 5XL",

  "Women's XS",

  "Women's Small",

  "Women's Medium",

  "Women's Large",

  "Women's XL",

  "Women's 2XL",

  "Women's 3XL",

  "Small",

  "Medium",

  "Large",

  "XL",
];

const comboValueTemplate = {
  availableColors: [],
  availableSizes: [],
  price: "",
  nonMemberPrice: "",
  salePrice: "",
  nonMemberSalePrice: "",
  shippingCost: "",
  unitCost: "",
  quantity: "",
};

const CreateItem = (props) => {
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const adminData = allGroups[currentGroup];
  const user = useUserStore(selectUserDetails); // eslint-disable-line no-unused-vars

  const [status, setStatus] = useState("");
  const [displayOn, setDisplayOn] = useState([]);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [hasSize, setHasSize] = useState(false);
  const [showSizes, setShowSizes] = useState(false);
  const [comboValues, setComboValues] = useState([JSON.parse(JSON.stringify(comboValueTemplate))]);
  const [productPrimaryImage, setProductPrimaryImage] = useState({
    image: "",
    color: "",
  });
  const [productOptionalImages, setProductOptionalImages] = useState([null, null, null, null]);
  const [errorInForm, setErrorInForm] = useState({
    isError: false,
    visible: false,
    message: "",
  });
  const [quantityPriceOption, setQuantityPriceOption] = useState("");
  const [sku, setSku] = useState(""); // eslint-disable-line no-unused-vars
  const [showColor, setShowColor] = useState(false);
  const [hasColor, setHasColor] = useState("");
  const [allColors, setAllColors] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleErrorMessageClose = () => {
    setErrorInForm((prevErrorInForm) => {
      const newErrorInForm = {
        ...prevErrorInForm,
      };
      newErrorInForm.visible = false;
      return newErrorInForm;
    });
  };

  const handleSubmit = async () => {
    try {
      if (
        !verifyStripeAccountId(
          adminData?.data?.paymentDetails?.stripeAccountId
        )
      ) {
        return;
      }

      setLoading(true);
      let stateData = {
        status,
        displayOn,
        name,
        desc,
        hasSize,
        showSizes,
        comboValues,
        productPrimaryImage,
        productOptionalImages,
        errorInForm,
        quantityPriceOption,
        sku,
        showColor,
        hasColor,
        allColors,
        loading,
      };
      if (
        productPrimaryImage &&
        productPrimaryImage?.image
      ) {
        if (typeof productPrimaryImage.image !== "string") {
          await uploadImage(
            productPrimaryImage.image,
            `/store/${currentGroup}/items/${Date.now()}`
          )
            .then(({ downloadUrl }) => downloadUrl)
            .then((url) => {
              stateData.productPrimaryImage.image = url;
            });
        }
      } else {
        window.scrollTo(0, 0);
        setErrorInForm({
          isError: true,
          visible: true,
          message: "Add product image.",
        });
        window.scrollTo(0, 0);
        setTimeout(handleErrorMessageClose, 5000);
        return;
      }

      let promises = stateData.productOptionalImages.map((image, index) => {
        if (image && image.image && typeof image.image !== "string") {
          return uploadImage(
            productOptionalImages[index] &&
              productOptionalImages[index].image,
            `/store/${currentGroup}/items/${moment.now()}`,
            index
          ).then(({ downloadUrl, index }) => {
            stateData.productOptionalImages[index].image = downloadUrl;
          });
        } else {
          if (!image || !image.image) {
            return new Promise((resolve) => {
              resolve(null);
            }).then((url) => {
              if (stateData.productOptionalImages[index])
                stateData.productOptionalImages[index].image = url;
            });
          }
        }
      });

      await Promise.all(promises);

      stateData.productOptionalImages = stateData.productOptionalImages.filter(
        (image) => image && image.image
      );

      let data = new StoreItem();
      data.toDataSet(stateData);

      data = JSON.parse(JSON.stringify(data));

      if (data.hasError) {
        window.scrollTo(0, 0);
        setErrorInForm({
          isError: true,
          visible: true,
          message: data.hasError.message,
        });
        window.scrollTo(0, 0);
        setTimeout(handleErrorMessageClose, 5000);
      } else {
        if (props.router.params.id) {
          await updateItem(
            props.router.params.id,
            currentGroup,
            data
          );
        } else {
          let batch = writeBatch(db);
          let docRef = collection(
            db,
            "store",
            currentGroup,
            "items"
          );

          await getDocs(docRef).then((snap) => {
            return snap.docs.map((doc) => {
              return batch.update(doc.ref, { sortIndex: increment(1) });
            });
          });

          await batch.commit();

          await addItem(currentGroup, data);
        }
        postUpdateCDNUtil(currentGroup, "store");
        props.router.navigate("/admin/store/merch");
      }
    } catch (error) {
      logger.error("Failed to create product: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = () => {
    if (props.router.params.id) {
      getItem(props.router.params.id, currentGroup).then(
        (data) => {
          let stateData = new StoreItem();
          stateData.fromDataSet(data);
          stateData = JSON.parse(JSON.stringify(stateData));

          if (stateData.status !== undefined) setStatus(stateData.status);
          if (stateData.displayOn !== undefined) setDisplayOn(stateData.displayOn);
          if (stateData.name !== undefined) setName(stateData.name);
          if (stateData.desc !== undefined) setDesc(stateData.desc);
          if (stateData.hasSize !== undefined) setHasSize(stateData.hasSize);
          if (stateData.showSizes !== undefined) setShowSizes(stateData.showSizes);
          if (stateData.comboValues !== undefined) setComboValues(stateData.comboValues);
          if (stateData.productPrimaryImage !== undefined) setProductPrimaryImage(stateData.productPrimaryImage);
          if (stateData.productOptionalImages !== undefined) setProductOptionalImages(stateData.productOptionalImages);
          if (stateData.errorInForm !== undefined) setErrorInForm(stateData.errorInForm);
          if (stateData.quantityPriceOption !== undefined) setQuantityPriceOption(stateData.quantityPriceOption);
          if (stateData.sku !== undefined) setSku(stateData.sku);
          if (stateData.showColor !== undefined) setShowColor(stateData.showColor);
          if (stateData.hasColor !== undefined) setHasColor(stateData.hasColor);
          if (stateData.allColors !== undefined) setAllColors(stateData.allColors);
          if (stateData.loading !== undefined) setLoading(stateData.loading);
        }
      );
    }
  };

  useEffect(() => {
    if (props.router.params.id) {
      fetchData();
    }
    getDoc(doc(db, "store", currentGroup)).then((docSnap) => {
      if (docSnap.exists()) {
        let data = docSnap.data();
        let newAllColors = data.colors;
        if (newAllColors && Array.isArray(newAllColors)) {
          setAllColors(newAllColors);
        }
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getRenderFieldPerQuantityPriceOption = () => {
    let groupCurrencyISO = adminData.data.paymentDetails
      ? adminData.data.paymentDetails.currency || "USD"
      : "USD";
    let groupCurrency = getCurrencyUnicode(groupCurrencyISO);
    if (quantityPriceOption === "single") {
      return (
        <>
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>Sizes</label>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
              <ChantCheckbox
                checked={hasSize}
                onChange={() => {
                  if (!hasSize) {
                    setHasSize(true);
                  } else {
                    setHasSize(false);
                    setShowSizes(false);
                  }
                }}
              />
              {hasSize && (
                <span
                  style={{ textDecoration: "underline", cursor: "pointer", width: "max-content" }}
                  onClick={() => setShowSizes((prev) => !prev)}
                >
                  Select available sizes
                </span>
              )}
              {comboValues[0]?.availableSizes?.length > 0 && (
                <span style={{ fontSize: "12px" }} onClick={() => setShowSizes((prev) => !prev)}>
                  <span style={{ textDecoration: "underline" }}>Selected:</span>{" "}
                  {comboValues[0].availableSizes.join(", ")}
                </span>
              )}
            </div>
          </div>

          {showSizes && (
            <div style={{ marginLeft: "16px", marginBottom: "16px" }}>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {allTshirtSizes.map((size) => (
                  <li key={size} style={{ display: "flex", gap: "8px" }}>
                    <ChantCheckbox
                      checked={comboValues[0].availableSizes ? comboValues[0].availableSizes.includes(size) : false}
                      onChange={() => {
                        let availableSizes = comboValues[0].availableSizes;
                        if (Array.isArray(availableSizes)) {
                          if (availableSizes.includes(size)) {
                            availableSizes.splice(availableSizes.indexOf(size), 1);
                          } else {
                            availableSizes.push(size);
                          }
                        }
                        let newComboValues = comboValues;
                        newComboValues[0].availableSizes = availableSizes;
                        setComboValues([...newComboValues]);
                      }}
                    >
                      {size}
                    </ChantCheckbox>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Colors
              <Tooltip
                title={<div style={{ width: 400 }}><span>Create color options in Store settings. Colors will then be available for selection when adding products.</span></div>}
                placement="topLeft"
              >
                <span className="border-0">&nbsp;<i className="fa fa-question-circle-o"></i></span>
              </Tooltip>
            </label>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
              <ChantCheckbox
                checked={hasColor}
                onChange={() => {
                  if (!hasColor) {
                    setHasColor(true);
                  } else {
                    setHasColor(false);
                    setShowColor(false);
                  }
                }}
              />
              {hasColor && (
                <span
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => setShowColor((prev) => !prev)}
                >
                  Select available colors
                </span>
              )}
              {comboValues[0]?.availableColors?.length > 0 && (
                <span style={{ fontSize: "12px" }} onClick={() => setShowSizes((prev) => !prev)}>
                  <span style={{ textDecoration: "underline" }}>Selected:</span>{" "}
                  {comboValues[0]?.availableColors.join(", ")}
                </span>
              )}
            </div>
          </div>

          {showColor && (
            <div style={{ marginLeft: "16px", marginBottom: "16px" }}>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {allColors.map((color) => (
                  <li key={color} style={{ display: "flex", gap: "8px" }}>
                    <ChantCheckbox
                      checked={comboValues[0].availableColors ? comboValues[0].availableColors.includes(color) : false}
                      onChange={() => {
                        let availableColors = comboValues[0].availableColors;
                        if (Array.isArray(availableColors)) {
                          if (availableColors.includes(color)) {
                            availableColors.splice(availableColors.indexOf(color), 1);
                          } else {
                            availableColors.push(color);
                          }
                        }
                        let newComboValues = comboValues;
                        newComboValues[0].availableColors = availableColors;
                        setComboValues([...newComboValues]);
                      }}
                    >
                      {color}
                    </ChantCheckbox>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Quantity
              <Tooltip
                placement="topLeft"
                title={() => (
                  <div style={{ width: 400 }}>
                    Leave blank if inventory is unlimited. Product will automatically show &apos;Low Quantity&apos; (when less than 10 remain) and Sold Out.
                  </div>
                )}
              >
                <span className="border-0">&nbsp;<i className="fa fa-question-circle-o"></i></span>
              </Tooltip>
            </label>
            <input
              className="form-control form-control-sm no-arrow-field"
              style={{ maxWidth: "200px" }}
              type="number"
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) >= 0) {
                  if (value.includes(".")) {
                    value = value.slice(0, value.indexOf("."));
                  }
                  let newComboValues = comboValues;
                  newComboValues[0].quantity = value;
                  setComboValues([...newComboValues]);
                }
              }}
              value={comboValues[0].quantity}
              step={1}
            />
          </div>

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Price({groupCurrency}) <span style={{ color: "red" }}>*</span>
              <Tooltip
                placement="topLeft"
                title={() => (
                  <div style={{ width: 400 }}>
                    Price displayed in app and registration form. Also displayed on web if &apos;non-member&apos; price is left blank.
                  </div>
                )}
              >
                <span className="border-0">&nbsp;<i className="fa fa-question-circle-o"></i></span>
              </Tooltip>
            </label>
            <input
              type="number"
              className="form-control form-control-sm no-arrow-field"
              style={{ maxWidth: "200px" }}
              onWheel={(e) => e.target.blur()}
              value={comboValues[0].price}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) >= 0) {
                  if (value.includes(".") && value.length - value.indexOf(".") > 2) {
                    value = value.slice(0, value.indexOf(".") + 3);
                  }
                  let newComboValues = comboValues;
                  newComboValues[0].price = value;
                  setComboValues([...newComboValues]);
                }
              }}
              step={0.1}
            />
          </div>

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Price (non-member) ({groupCurrency})
              <Tooltip
                placement="topLeft"
                title={() => <div style={{ width: 400 }}>If entered, displayed on web.</div>}
              >
                <span className="border-0">&nbsp;<i className="fa fa-question-circle-o"></i></span>
              </Tooltip>
            </label>
            <input
              type="number"
              className="form-control form-control-sm no-arrow-field"
              style={{ maxWidth: "200px" }}
              onWheel={(e) => e.target.blur()}
              value={comboValues[0].nonMemberPrice}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) >= 0) {
                  if (value.includes(".") && value.length - value.indexOf(".") > 2) {
                    value = value.slice(0, value.indexOf(".") + 3);
                  }
                  let newComboValues = comboValues;
                  newComboValues[0].nonMemberPrice = value;
                  setComboValues([...newComboValues]);
                }
              }}
              step={0.1}
            />
          </div>

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Sale Price ({groupCurrency})
              <Tooltip
                placement="topLeft"
                title={() => (
                  <div style={{ width: 400 }}>
                    Sale Price displayed in app and registration form. Also displayed on web if &apos;non-member&apos; sale price is left blank.
                  </div>
                )}
              >
                <span className="border-0">&nbsp;<i className="fa fa-question-circle-o"></i></span>
              </Tooltip>
            </label>
            <input
              type="number"
              className="form-control form-control-sm no-arrow-field"
              style={{ maxWidth: "200px" }}
              onWheel={(e) => e.target.blur()}
              value={comboValues[0].salePrice}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) >= 0) {
                  if (value.includes(".") && value.length - value.indexOf(".") > 2) {
                    value = value.slice(0, value.indexOf(".") + 3);
                  }
                  let newComboValues = comboValues;
                  newComboValues[0].salePrice = value;
                  setComboValues([...newComboValues]);
                }
              }}
              step={0.1}
            />
          </div>

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Sale Price (non-member) ({groupCurrency})
              <Tooltip
                placement="topLeft"
                title={() => <div style={{ width: 400 }}>If entered, displayed on web.</div>}
              >
                <span className="border-0">&nbsp;<i className="fa fa-question-circle-o"></i></span>
              </Tooltip>
            </label>
            <input
              type="number"
              className="form-control form-control-sm no-arrow-field"
              style={{ maxWidth: "200px" }}
              onWheel={(e) => e.target.blur()}
              value={comboValues[0].nonMemberSalePrice}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) >= 0) {
                  if (value.includes(".") && value.length - value.indexOf(".") > 2) {
                    value = value.slice(0, value.indexOf(".") + 3);
                  }
                  let newComboValues = comboValues;
                  newComboValues[0].nonMemberSalePrice = value;
                  setComboValues([...newComboValues]);
                }
              }}
              step={0.1}
            />
          </div>

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Shipping Cost ({groupCurrency})
              <Tooltip
                placement="topLeft"
                title={() => (
                  <div style={{ width: 400 }}>
                    Leave blank if shipping not available. Shipping amounts added together for each item at checkout.
                  </div>
                )}
              >
                <span className="border-0">&nbsp;<i className="fa fa-question-circle-o"></i></span>
              </Tooltip>
            </label>
            <input
              type="number"
              className="form-control form-control-sm no-arrow-field"
              style={{ maxWidth: "200px" }}
              onWheel={(e) => e.target.blur()}
              value={comboValues[0].shippingCost}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) >= 0) {
                  if (value.includes(".") && value.length - value.indexOf(".") > 2) {
                    value = value.slice(0, value.indexOf(".") + 3);
                  }
                  let newComboValues = comboValues;
                  newComboValues[0].shippingCost = value;
                  setComboValues([...newComboValues]);
                }
              }}
              step={0.1}
            />
          </div>

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Unit Cost (Internal) ({groupCurrency})
              <Tooltip
                placement="topLeft"
                title={() => <div style={{ width: 400 }}>Not displayed publicly.</div>}
              >
                <span className="border-0">&nbsp;<i className="fa fa-question-circle-o"></i></span>
              </Tooltip>
            </label>
            <input
              type="number"
              className="form-control form-control-sm no-arrow-field"
              style={{ maxWidth: "200px" }}
              onWheel={(e) => e.target.blur()}
              value={comboValues[0].unitCost}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) >= 0) {
                  if (value.includes(".") && value.length - value.indexOf(".") > 2) {
                    value = value.slice(0, value.indexOf(".") + 3);
                  }
                  let newComboValues = comboValues;
                  newComboValues[0].unitCost = value;
                  setComboValues([...newComboValues]);
                }
              }}
              step={0.1}
            />
          </div>
        </>
      );
    }

    if (quantityPriceOption === "perCombination") {
      const columns = [
        {
          title: "Size",
          dataIndex: "availableSizes",
          className: "header-white",
          width: 150,
          render: (size, _, index) => (
            <select
              value={size[0]}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].availableSizes = [e.target.value];
                setComboValues([...newComboValues]);
              }}
            >
              <option value={""} key="select">
                --Select size--
              </option>
              {allTshirtSizes.map((sizeOption) => {
                return (
                  <option value={sizeOption} key={sizeOption}>
                    {sizeOption}
                  </option>
                );
              })}
            </select>
          ),
        },
        {
          title: (
            <div>
              Color
              <Tooltip
                title={
                  <div style={{ width: 400 }}>
                    <span>
                      Create color options in Store settings. Colors will then
                      be available for selection when adding products.
                    </span>
                  </div>
                }
                placement="topLeft"
              >
                <span className="border-0">
                  &nbsp;<i className="fa fa-question-circle-o"></i>
                </span>
              </Tooltip>
            </div>
          ),
          dataIndex: "availableColors",
          className: "header-white",
          width: 150,
          render: (color, _, index) => (
            <select
              value={color[0]}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].availableColors = [e.target.value];
                newComboValues[index].availableColors = newComboValues[
                  index
                ].availableColors.filter((c) => c);
                setComboValues([...newComboValues]);
              }}
            >
              <option value={""} key="select">
                --Select color--
              </option>
              {allColors.map((colorOption) => {
                return (
                  <option value={colorOption} key={colorOption}>
                    {colorOption}
                  </option>
                );
              })}
            </select>
          ),
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          className: "header-white",
          width: 70,
          render: (quantity, _, index) => (
            <input
              type="number"
              value={quantity}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].quantity = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
        {
          title: "Sold",
          dataIndex: "sold",
          className: "header-white",
          width: 70,
          render: (quantity, _, index) => (
            <input
              type="number"
              disabled={true}
              value={quantity}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].quantity = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
        {
          title: "Remaining",
          className: "header-white",
          width: 70,
          render: (record, _, index) => (
            <input
              type="number"
              disabled={true}
              value={(record.quantity || 0) - (record.sold || 0)}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].quantity = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
        {
          title: (
            <div>
              Price ({groupCurrency})<span style={{ color: "red" }}>*</span>
            </div>
          ),
          dataIndex: "price",
          className: "header-white",
          width: 100,
          render: (price, _, index) => (
            <input
              type="number"
              value={price}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].price = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
        {
          title: <div>Sale Price ({groupCurrency})</div>,
          dataIndex: "salePrice",
          className: "header-white",
          width: 100,
          render: (salePrice, _, index) => (
            <input
              type="number"
              value={salePrice}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].salePrice = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
        {
          title: <div>Non Member ({groupCurrency})</div>,
          dataIndex: "nonMemberPrice",
          className: "header-white",
          width: 100,
          render: (nonMemberPrice, _, index) => (
            <input
              type="number"
              value={nonMemberPrice}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].nonMemberPrice = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
        {
          title: <div>Sale Price (non-member) ({groupCurrency})</div>,
          dataIndex: "nonMemberSalePrice",
          className: "header-white",
          width: 100,
          render: (salePrice, _, index) => (
            <input
              type="number"
              value={salePrice}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].nonMemberSalePrice = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
        {
          title: <div>Shipping Cost ({groupCurrency})</div>,
          dataIndex: "shippingCost",
          className: "header-white",
          width: 100,
          render: (shippingCost, _, index) => (
            <input
              type="number"
              value={shippingCost}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].shippingCost = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
        {
          title: (
            <div>
              <p style={{ margin: 0 }}>Unit Cost</p>
              <p>(Internal) ({groupCurrency})</p>
            </div>
          ),
          dataIndex: "unitCost",
          width: 100,
          className: "header-white",
          render: (unitCost, _, index) => (
            <input
              type="number"
              value={unitCost}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let newComboValues = comboValues;
                newComboValues[index].unitCost = e.target.value;
                setComboValues([...newComboValues]);
              }}
              style={{
                borderRadius: 3,
                width: "100%",
                border: "1px solid #ced4da",
              }}
            />
          ),
        },
      ];

      return (
        <>
          <p>Create Price, Quantity, Size and Color combinations.</p>
          <Table
            dataSource={comboValues}
            columns={columns}
            pagination={false}
            bordered
          />
          <span
            style={{
              color: "#3480eb",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              let newComboValues = comboValues;
              let object = JSON.parse(JSON.stringify(comboValueTemplate));
              // if (allColors && Array.isArray(allColors)) {
              //     object.availableColors = [allColors[0]];
              // }
              // object.availableSizes = [allTshirtSizes[0]];
              newComboValues.push(object);
              setComboValues([...newComboValues]);
            }}
          >
            + Add Row
          </span>
        </>
      );
    }
  };

  let allSelectedColors = [];
  comboValues.forEach((combo) => {
    allSelectedColors.push(...combo.availableColors);
  });
  let selectedColors = Array.from(new Set(allSelectedColors));

  return (
    <div className="col">
      {errorInForm.isError && errorInForm.visible && (
        <div className="mx-5 mt-2">
          <Alert
            message="Error"
            description={errorInForm.message}
            type="error"
            closable
            // className="mb-3"
            afterClose={handleErrorMessageClose}
          />
        </div>
      )}

      <div style={{ padding: "12px" }}>
        <ScreenHeader title="Add Product" />

        <div style={{ marginTop: "2px" }}>
          <DescriptionText showBackground>
            Products can be set to show across your Chant website, a
            standalone web page, the app and with registration packages.
            Ensure you have first completed the &apos;Store Settings&apos;
            form.
          </DescriptionText>
        </div>

        <div
          style={{
            marginTop: "2px",
            backgroundColor: "#ffffff",
            padding: "12px",
          }}
        >
          <div className="chant-form-body">
              <div
                style={{ display: "flex", flexWrap: "wrap" }}
                className="mb-3"
              >
                <span
                  style={{
                    fontSize: 19,
                    fontWeight: "bold",
                  }}
                >
                  General
                </span>
              </div>
              <ChantSelect
                label="Status"
                required
                value={status}
                onChange={(value) => setStatus(value)}
                options={statuses.map((item) => ({
                  value: item.key,
                  label: item.value,
                }))}
                placeholder="---Select status---"
              />
              <div style={{ marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px" }}>
                  <label style={{ marginBottom: 0 }}>
                    Display On<span style={{ color: "red" }}>*</span>
                  </label>
                  <Tooltip
                    placement="topLeft"
                    title={() => (
                      <div style={{ width: 400 }}>
                        Required if Status set to 'Live'. Web & Registration
                        only relevant if group uses those Chant features.
                      </div>
                    )}
                  >
                    <span className="border-0">
                      &nbsp;<i className="fa fa-question-circle-o"></i>
                    </span>
                  </Tooltip>
                </div>
                <div>
                  {displayOptions.map((option) => (
                    <div
                      key={option.value}
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <ChantCheckbox
                        checked={displayOn.includes(option.value)}
                        onChange={() => {
                          let isPresent = displayOn.includes(option.value);
                          if (isPresent) {
                            let newDisplayOn = displayOn;
                            newDisplayOn.splice(
                              newDisplayOn.indexOf(option.value),
                              1
                            );
                            setDisplayOn([...newDisplayOn]);
                          } else {
                            let newDisplayOn = displayOn;
                            newDisplayOn.push(option.value);
                            setDisplayOn([...newDisplayOn]);
                          }
                        }}
                      />
                      <span
                        style={{
                          width: "fit-content",
                          minWidth: "80px",
                          fontSize: 12,
                          fontWeight: "bold",
                          marginRight: "8px",
                        }}
                      >
                        {option.label}
                      </span>
                      <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                        {option.helpText}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px" }}>
                  <label style={{ marginBottom: 0 }}>
                    Product Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <Tooltip
                    placement="topLeft"
                    title={() => (
                      <div style={{ width: 400 }}>
                        Limit of 50 characters.
                      </div>
                    )}
                  >
                    <span className="border-0">
                      &nbsp;<i className="fa fa-question-circle-o"></i>
                    </span>
                  </Tooltip>
                </div>
                <ChantInput
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  maxLength={50}
                />
              </div>
              <div style={{ marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px" }}>
                  <label style={{ marginBottom: 0 }}>Description</label>
                  <Tooltip
                    placement="topLeft"
                    title={() => (
                      <div style={{ width: 400 }}>
                        Limit of 500 characters.
                      </div>
                    )}
                  >
                    <span className="border-0">
                      &nbsp;<i className="fa fa-question-circle-o"></i>
                    </span>
                  </Tooltip>
                </div>
                <Input.TextArea
                  rows={2}
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                  maxLength={500}
                />
              </div>
              <div style={{ marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px" }}>
                  <label style={{ marginBottom: 0 }}>
                    Quantity/Price<span style={{ color: "red" }}>*</span>
                  </label>
                  <Tooltip
                    placement="topLeft"
                    title={() => (
                      <div style={{ width: 400 }}>
                        Create products with a single quantity and price
                        values (scarf) or set quantity and price by size
                        and/or color.
                      </div>
                    )}
                  >
                    <span className="border-0">
                      &nbsp;<i className="fa fa-question-circle-o"></i>
                    </span>
                  </Tooltip>
                </div>
                <ChantSelect
                  value={quantityPriceOption}
                  onChange={(value) => {
                    let newHasColor = hasColor;
                    let newHasSize = hasSize;
                    let newComboValues = comboValues;

                    if (value === "single") {
                      newComboValues = [
                        JSON.parse(JSON.stringify(comboValueTemplate)),
                      ];
                    }
                    if (value === "perCombination") {
                      newHasColor = true;
                      newHasSize = true;
                    }
                    setQuantityPriceOption(value);
                    setHasColor(newHasColor);
                    setHasSize(newHasSize);
                    setComboValues(newComboValues);
                  }}
                  options={quantityPerPriceOption.map((item) => ({
                    value: item.key,
                    label: item.value,
                  }))}
                  placeholder="---Select option---"
                />
              </div>
          </div>

          <Divider className="my-2" />

          {quantityPriceOption && (
            <div>
              <div className="col-md-12 mb-4">
                <div
                  style={{ display: "flex", flexWrap: "wrap" }}
                  className="mb-3"
                >
                  <span
                    style={{
                      fontSize: 19,
                      fontWeight: "bold",
                    }}
                  >
                    Details
                  </span>
                </div>

                {getRenderFieldPerQuantityPriceOption()}
              </div>

              <Divider className="my-2" />
            </div>
          )}

          <div className="chant-form-body">
              <div
                style={{ display: "flex", flexWrap: "wrap" }}
                className="mb-3"
              >
                <span
                  style={{
                    fontSize: 19,
                    fontWeight: "bold",
                  }}
                >
                  Images
                </span>
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label>Product Images<span style={{ color: "red" }}>*</span></label>
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                    }}
                  >
                    {/* Primary Image Card */}
                    <div
                      style={{
                        backgroundColor: "white",
                        border: "1px solid #e8e8e8",
                        borderRadius: "8px",
                        padding: "16px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                      }}
                    >
                      <div
                        style={{
                          marginBottom: "8px",
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#262626",
                        }}
                      >
                        Primary Image
                      </div>
                      <ImageUploadButton
                        images={[productPrimaryImage.image]}
                        onSave={(images) => {
                          setProductPrimaryImage({
                            ...productPrimaryImage,
                            image: images[0],
                          });
                        }}
                        text="Upload"
                        aspectRatio={1}
                      />
                      {selectedColors.length > 0 && (
                        <div style={{ marginTop: "12px" }}>
                          <label
                            style={{
                              display: "block",
                              marginBottom: "6px",
                              fontSize: "13px",
                              color: "#595959",
                            }}
                          >
                            Color
                          </label>
                          <select
                            style={{
                              width: "100%",
                              padding: "6px 8px",
                              borderRadius: "4px",
                              border: "1px solid #d9d9d9",
                              fontSize: "14px",
                            }}
                            value={productPrimaryImage.color}
                            onChange={(e) => {
                              setProductPrimaryImage({
                                ...productPrimaryImage,
                                color: e.target.value,
                              });
                            }}
                          >
                            <option value={""} key="select">
                              --Select color--
                            </option>
                            {selectedColors.map((color) => (
                              <option key={color} value={color}>
                                {color}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>

                    {/* Optional Images Grid */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(280px, 1fr))",
                        gap: "16px",
                        width: "100%",
                      }}
                    >
                      {productOptionalImages.map(
                        (optionalImg, index) => (
                          <div
                            key={`optional-image-${index}`}
                            style={{
                              backgroundColor: "white",
                              border: "1px solid #e8e8e8",
                              borderRadius: "8px",
                              padding: "16px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                            }}
                          >
                            <div
                              style={{
                                marginBottom: "8px",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#262626",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              Additional Image {index + 1}
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#8c8c8c",
                                }}
                              >
                                (optional)
                              </span>
                            </div>
                            <ImageUploadButton
                              images={[optionalImg && optionalImg.image]}
                              onSave={(images) => {
                                let newProductOptionalImages = [
                                  ...productOptionalImages,
                                ];
                                newProductOptionalImages[index] = {
                                  ...newProductOptionalImages[index],
                                  image: images[0],
                                };
                                setProductOptionalImages(newProductOptionalImages);
                              }}
                              text="Upload"
                              aspectRatio={1}
                            />
                            {selectedColors.length > 0 && (
                              <div style={{ marginTop: "12px" }}>
                                <label
                                  style={{
                                    display: "block",
                                    marginBottom: "6px",
                                    fontSize: "13px",
                                    color: "#595959",
                                  }}
                                >
                                  Color
                                </label>
                                <select
                                  style={{
                                    width: "100%",
                                    padding: "6px 8px",
                                    borderRadius: "4px",
                                    border: "1px solid #d9d9d9",
                                    fontSize: "14px",
                                  }}
                                  value={optionalImg && optionalImg.color}
                                  onChange={(e) => {
                                    let newProductOptionalImages = [
                                      ...productOptionalImages,
                                    ];
                                    newProductOptionalImages[index] =
                                      newProductOptionalImages[index] || {};
                                    newProductOptionalImages[index].color =
                                      e.target.value;
                                    setProductOptionalImages(newProductOptionalImages);
                                  }}
                                >
                                  <option value={""} key="select">
                                    --Select color--
                                  </option>
                                  {selectedColors.map((color) => (
                                    <option key={color} value={color}>
                                      {color}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <Divider className="my-2" />

          <div className="d-flex justify-content-center my-2">
            <ChantButton
              onClick={handleSubmit}
              loading={loading}
              disabled={
                loading ||
                !name ||
                !quantityPriceOption ||
                !productPrimaryImage.image
              }
            >
              Submit
            </ChantButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(CreateItem);
